// Formats a job's stored salary for display, e.g. "1000.00" -> "1,000 per year".
// The API stores no currency, so none is shown here; the card's existing dollar icon is
// the only currency hint. Non-numeric values (e.g. "Negotiable") are shown as written.
export function formatSalary(salary) {
  if (salary === null || salary === undefined || String(salary).trim() === "") return "N/A";
  const n = Number(String(salary).replace(/,/g, ""));
  if (Number.isFinite(n)) {
    return `${n.toLocaleString("en-US", { maximumFractionDigits: 2 })} per year`;
  }
  return String(salary).trim();
}
